import React from "react";
import Marquee from "react-fast-marquee";
import { MARQUEE_WORDS } from "@/data/site";

export const BrandMarquee = () => {
  return (
    <section className="bg-white py-10 border-y border-gray-100 overflow-hidden" data-testid="marquee">
      <Marquee speed={40} gradient gradientColor="#ffffff" gradientWidth={120} autoFill>
        {MARQUEE_WORDS.map((w) => (
          <span key={w} className="mx-8 inline-flex items-center gap-8">
            <span className="font-heading font-extrabold tracking-tighter text-6xl sm:text-7xl text-gray-100 select-none">
              {w}
            </span>
            <span className="h-3 w-3 rounded-full bg-brand-accent/30" />
          </span>
        ))}
      </Marquee>
    </section>
  );
};
